import axios from '@axios'
import moment from 'moment'

const getInitialState = () => ({
  // Loja filtrada no painel; nula = todas as lojas que o usuário acessa.
  storeId: null,
})

export default {
  namespaced: true,
  state: getInitialState(),

  mutations: {
    SET_STORE_ID(state, storeId) {
      state.storeId = storeId || null
    },
    CLEAN_STATE(state) {
      Object.assign(state, getInitialState())
    },
  },

  actions: {
    setStoreId({ commit }, storeId) {
      commit('SET_STORE_ID', storeId)
    },

    // Agendamentos de chope/comodato ativos que tocam [from, to). Sem lojas, a API devolve todas
    // as lojas do usuário (sem enviar "storeIds=", que a API interpretaria como valor vazio).
    async fetchSchedules(_, { from, to, storeIds = [] }) {
      const { data } = await axios.get('/api/sales/lending-schedules', {
        params: {
          from: moment(from).format(),
          to: moment(to).format(),
          ...(storeIds.length ? { storeIds } : {}),
        },
      })
      return data || []
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
